document.addEventListener('DOMContentLoaded', function() {
        var modal = document.getElementById('ageModal');
        var verifyButton = document.getElementById('verifyAge');
        // var denyButton = document.getElementById('denyAccess');

        // Check if the user has already verified their age in this session
        if (sessionStorage.getItem('ageVerified')) {
            modal.style.display = "none";
        } else {
            // Show modal on page load if age has not been verified
            modal.style.display = "block";
        }

        verifyButton.onclick = function() {
            modal.style.display = "none";
            // Store verification in session storage
            sessionStorage.setItem('ageVerified', 'true');
        };

        // denyButton.onclick = function() {
        //     modal.innerHTML = "<div class='modal-content'><h2>Access Denied</h2><p>Sorry, you are not of legal age to enter this site.</p></div>";
        //     // Optionally, you might want to clear the session or take some other action here
        // };

        


});